module.exports = __webpack_public_path__ + "fonts/AlimamaShuHeiTi-Bold.50f39ed4.ttf";